import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default async ({ caseId, factId, input }) => {
	const query = gql`
		mutation updateFactOfCase(
			$caseId: String!
			$factId: String!
			$input: updateFactInput!
		) {
			updateFactOfCase(caseId: $caseId, factId: $factId, input: $input) {
				status
				errors
			}
		}
	`

	const res = await api({
		query,
		variables: { caseId, factId, input }
	})
	return Promise.resolve(res)
}
